<template>
  <Dialog
    :visible.sync="display"
    :style="{ width: '90vw' }"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <span>{{ $t("Confirmation.Confirmation") }}</span>
    </template>

    {{ question }}
    <div class="field-checkbox">
      <Checkbox inputId="customCheckBox" v-model="checked" :binary="true" />
      <label for="customCheckBox" style="margin-bottom: 0px">{{
        checkBoxMessage
      }}</label>
    </div>
    <template #footer>
      <Button label="Ok" icon="pi pi-check" @click="onClick()" />
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "SingleButtonConfirmation",
  props: ["display", "question", "checkBoxMessage"],
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    onClick() {
      if (this.checked) {
        this.$emit("confirmed", true);
      } else {
        this.$emit("confirmed", false);
      }
    },
  },
};
</script>
